export const sanitiseAccountNumber = (accountNumber: string): string => accountNumber.replace(/X/g, "");
